$(document).ready(function() {
    $(document).on('click', '.js-reg', function() {
        if (!($('.b-header').hasClass('menu'))) {
        	$('body').toggleClass('is-modal-open');
        }
        $('.b-header').toggleClass('modal');
        if ($('.b-modal--reg').is(":visible")) {
            $('.b-modal--reg').hide();
        } else {
            $('.b-modal--reg').show();
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/general/reg.js